import { trpc } from '../services/trpc';

export function useUser() {
  const query = trpc.auth.me.useQuery();
  return {
    user: query.data!,
  };
}
